/* eslint-disable max-len */
const React = require('react');
const PredesignES = require('./predesignES');
const PredesignPT = require('./predesignPT');
const PredesignREPT = require('./predesignREPT');
const PredesignREES = require('./predesignREES');

const Predesign = {
  es: PredesignES,
  pt: PredesignPT,
  en: PredesignES,
  're-pt': PredesignREPT,
  're-es': PredesignREES,
  're-en': PredesignREES,
};

module.exports = Predesign;
